import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { IndexComponent } from './index/index.component';
import { RewardsComponent } from './rewards/rewards.component';
import { SubsetComponent } from './subset/subset.component';
import { FinancialComponent } from './financial/financial.component';
import { ReportsComponent } from './reports/reports.component';
import { ChartsComponent } from './index/charts/charts.component';
import { ScoreDgComponent } from './subset/score-dg/score-dg.component';
import { LoaddingModule } from './shared/loadding/loadding.module';

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    RewardsComponent,
    SubsetComponent,
    FinancialComponent,
    ReportsComponent,
    ChartsComponent,
    ScoreDgComponent,
  ],
  imports: [
    CoreModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    LoaddingModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
